// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JSjO","left":"styles_left__2m119"};